module.exports = __webpack_public_path__ + "images/life.57d066bb1559ae476bc35c8e3ba8284a.svg";